import { createGlobalStyle } from "styled-components";

export const DURATION = 150;

export const GlobalStyle = createGlobalStyle`
    :root {
        --duration: ${DURATION}ms;
    }
`;
